import { auth } from '@/firebase';
import axios from 'axios';

const api = axios.create();

api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {      
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;